<template>
    <ProjectData />
    <BoardData />
    <PriorityData />
    <TeamMemberData />
    <LabelData />
    <div class="card overflow-hidden">
		<nav class="tsk_tabs">
			<div class="nav nav-tabs m-0" id="nav-tab" role="tablist">
				<button class="nav-link active tabLinkCls">List</button>
                <router-link to="/tasks-kanban" class="nav-link" id="nav-karban-tab" >
                    <span class="tabLinkCls">Kanban</span>
                </router-link>
                <router-link to="/tasks-archive" class="nav-link" id="nav-archive-tab" >
                    <span class="tabLinkCls">Archive</span>
                </router-link>
			</div>
            <div class="mg-right_divselt">
                <vs-button class="mg-btn-gold me-3" v-on:click="manageLabelsBtn"  color="primary" text-color="whiteprimary" v-if="$store.state.user.userInfo.role_name === 'Admin'"><LabelsSvgIcon />Add labels</vs-button>
                <vs-button class="mg-btn-gold"  v-on:click="addTaskBtn" color="primary" text-color="whiteprimary"><AddSvgIcon />Add Task</vs-button>  
            </div>
		</nav>
		<div class="tab-content p-0" id="nav-tabContent">
            <div class="tab-pane fade active show" id="nav-list" role="tabpanel" aria-labelledby="nav-list-tab">
                <div class="card border-0">
                    <!-- <div class="card-header py-3">
                        <h6 class="m-0 font-weight-bold text-primary">Tasks</h6>
                    </div> -->
          <div class="sectionclsbodymain tsk_body_right_back">
            <Tasks />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tasks from "../components/Tasks/index.vue";
import ProjectData from "../components/Projects/ProjectData.vue";
import PriorityData from "../components/Priority/PriorityData.vue";
import BoardData from "../components/Board/BoardData.vue";
import TeamMemberData from "../components/TeamMember/TeamMemberData.vue";
import LabelData from "../components/Label/LabelData.vue";
import AddSvgIcon from "../components/Widgets/Icon/AddSvgIcon.vue";
import LabelsSvgIcon from "../components/Widgets/Icon/LabelsSvgIcon.vue";
import $ from "jquery";
export default {
  name: "TasksPage",
  components: {
    Tasks,
    ProjectData,
    PriorityData,
    BoardData,
    TeamMemberData,
    LabelData,
    AddSvgIcon,
    LabelsSvgIcon,
  },
  async mounted() {
    if (window.innerWidth < 1025) {
      $(".firstHeightCls").height(window.innerHeight);
    } else {
      const bHeight = $("body").height();
      $(".firstHeightCls").height(bHeight - 30);
    }
    $("#content").addClass("firstHeightCls");
    this.$store.state.NotifiCheckVal = Math.ceil(Math.random() * 1000000);
    if (this.$store.state.isActiveToken != "1") {
      // console.log(this.currentDate);
    }
    this.$store.state.projectIdSelected = "";
    if ($(".sectionbody").hasClass("showMobileMenu")) {
      $(".sectionbody").removeClass("showMobileMenu");
    }
  },
  methods: {
    async addTaskBtn() {
      document.getElementById("addTaskMainBtn").click();
    },
    async manageLabelsBtn() {
      document.getElementById("addManageLabelsBtn").click();
    },
  },
};
</script>
